const translations = {
  'entryReq.seo.title': 'Requisitos de ingreso para un curso Trinity TESOL TEFL en España',
  'entryReq.seo.description': `Obtén más información sobre los requisitos de ingreso para el curso Trinity CertTESOL TEFL de 160 horas y 1 mes de TEFL Iberia.`,
  'entryReq.sec1.title': 'Requisitos de Admisión',

  'entryReq.sec2.benefitsTitle': 'Para inscribirse en TEFL Iberia, los solicitantes deben:',
  'entryReq.sec2.ben1': 'Tener más de 18 años de edad.',
  'entryReq.sec2.ben2':
    'Demostrar habilidades para comunicarse de manera oral y escrita inglés, con un nivel avanzado (C1). Ten en cuenta: ¡no se requiere ser hablante nativo de inglés!',
  'entryReq.sec2.ben3':
    'Mostrar entusiasmo y pasión tanto por la enseñanza como por el aprendizaje.',
  'entryReq.sec2.ben4':
    'Poseer las habilidades cognitivas necesarias para enfrentar las exigencias de este curso, lo cual puede demostrarse a través de un título de educación superior o experiencia laboral previa.',
  'entryReq.sec2.ben5':
    'Gozar de buena salud física para hacer frente a las exigencias físicas de una agenda diaria de enseñanza.',
  'entryReq.sec2.ben6':
    'Tener una actitud ganadora y sobresaliente; hay una razón por la cual aceptamos solo al 98% de los solicitantes, ¡y es porque solo admitimos personas amigables con pasión por la excelencia!',
  'entryReq.sec2.text':
    'Para ser aceptado/a en el curso, necesitas completar una breve entrevista (20-25 minutos) con uno/a de nuestros/as coordinadores/as de curso, para hablar sobre tus opciones, lo que deseas obtener del curso y tus planes posteriores.',
};

export default translations;
